import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OpenRouteCMRController } from '@shared/src/controllers/open/openroutecmr.controller';
import { RouteCMRController } from '@shared/src/controllers/route/cmr/routecmr.controller';
import { Route_eCMRPlatesDto } from '@shared/src/dtos/route/cmr/ecmrparts/Route_eCMRPlatesDto';

@Component({
  selector: 'updateplatesdialog-dialog',
  templateUrl: './updateplatesdialog.dialog.component.html'
})
export class UpdatePlatesDialogDialogComponent {

  @Output() public onResolve: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private mdDialogRef: MatDialogRef<UpdatePlatesDialogDialogComponent>,
    private mdDialog: MatDialog,
    private ecmrController: RouteCMRController,
    private openEcmrController: OpenRouteCMRController) { }

  onClose() {
    this.onResolve.next(false);
    this.mdDialog.closeAll();
  }

  onConfirm() {
    if (!this.data.external) {
      this.ecmrController.updatePlates(this.data.routePartCMRId, Route_eCMRPlatesDto.build(this.data.plateA, this.data.plateB, this.data.plateC)).subscribe(e => {
        if (e) {
          this.onResolve.next(true);
          this.mdDialog.closeAll();
        }
      });
    } else {
      this.openEcmrController.updatePlates(this.data.routePartCMRId, Route_eCMRPlatesDto.build(this.data.plateA, this.data.plateB, this.data.plateC)).subscribe(e => {
        if (e) {
          this.onResolve.next(true);
          this.mdDialog.closeAll();
        }
      });
    }
  }
}
